import React from "react";

export default function AdjustmentListReportComponent() {
  return <div></div>;
}
